import { createRequestTypes } from '../utils';

export const FETCH_MANDATES = createRequestTypes('mandate/FETCH_MANDATES');
export const SAVE_MANDATE = createRequestTypes('mandate/SAVE_MANDATE');
